import {
  ADD_ARTIST_SUCCESS,
  ADD_ARTIST_FAILED,
  CLEAR_ADD_ARTIST,
} from '../../actionTypes';

const initialState = {
  status: '',
  message: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ADD_ARTIST_SUCCESS:
      return {
        ...state,
        status: 'success',
        message: action.message,
      };
    case ADD_ARTIST_FAILED:
      return { ...state, status: 'error', error: action.error };
    case CLEAR_ADD_ARTIST:
      return initialState;
    default:
      return state;
  }
};
